import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
const General = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content">
          <div className="container px-0">
            <div className="accordion mt-3" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseOne"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseOne"
                  >
                    <div className="col d-flex align-items-center">
                      <h4 className="event-alert p-0 mb-0">Income</h4>
                    </div>{" "}
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingOne"
                >
                  <div className="row mx-0">
                    <div className="container px-0">
                      <div className="row">
                        <div class="col-md-12">
                          <div className="shadowclass mt-2">
                            <div class="inventory_summary_master">
                              <div class="row-fluid">
                                <div class="col-12">
                                  <div class="counts date_new_Cont">
                                    <h4 class="event-alert">
                                      Select Your Period
                                    </h4>

                                    <div class="half_new_div d-flex">
                                      <a href="#_" class="date_label">
                                        <i class="iconSprites arrow-left"></i>{" "}
                                      </a>{" "}
                                      <span class="date-text">
                                        May 1, 2022 - May 12, 2022
                                      </span>
                                      <span class="clander_icon"></span>
                                    </div>

                                    <div class="half_right_div">
                                      <ul class="summary_filter add">
                                        <li class="">
                                          <a href="/finance_summary/general/timeLimit:day">
                                            Day
                                          </a>{" "}
                                        </li>
                                        <li class="">
                                          <a href="/finance_summary/general/timeLimit:week">
                                            Week
                                          </a>{" "}
                                        </li>
                                        <li class="active">
                                          <a href="/finance_summary/general/timeLimit:month">
                                            Month
                                          </a>{" "}
                                        </li>
                                        <li class="">
                                          <a href="/finance_summary/general/timeLimit:quarter">
                                            Quarter
                                          </a>{" "}
                                        </li>
                                        <li class="">
                                          <a href="/finance_summary/general/timeLimit:year">
                                            Year
                                          </a>{" "}
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="shadowclass mt-3">
                            <div class="col-12">
                              <div class="select-comparison">
                                <label class="key">Key Statistics Vs.</label>
                                <div class="select-div widthextra">
                                  <select
                                    name="data[comparison]"
                                    class="comparison"
                                    id="comparison"
                                  >
                                    <option value="">Select Comparison</option>
                                    <option value="0" selected="selected">
                                      Previous Period
                                    </option>
                                    <option value="1">
                                      Same Period Previous Year
                                    </option>
                                  </select>{" "}
                                </div>
                              </div>
                            </div>
                            <div class="col-12 m-0">
                              <ul class="comparison_listing statistics_data">
                                <li>
                                  <h4>
                                    $3,406 <span class="before">77%</span>{" "}
                                  </h4>
                                  <p>Total Revenue</p>
                                </li>
                                <li>
                                  <h4>94 </h4>
                                  <p>Total # of Transactions</p>
                                </li>
                                <li>
                                  <h4>
                                    $284 <span class="before">53%</span>{" "}
                                  </h4>
                                  <p>Avg. Revenue Per Day</p>
                                </li>
                                <li>
                                  <h4>8 </h4>
                                  <p>Avg. # of Transactions Per Day</p>
                                </li>
                                <li>
                                  <h4>
                                    <span class="com-sign">$36</span>
                                  </h4>
                                  <p>Avg. Ticket Amount</p>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-lg-6 distri-nw mt-3">
                          <div class="shadowclass h-100 mt-0">
                            <h4 class="event-alert summary-event-alert">
                              Sales Trending{" "}
                            </h4>
                            <div class="select-comparison">
                              <label>Select Metric</label>
                              <div class="select-div">
                                <select
                                  name="data[dwaa]"
                                  class="sales_metric"
                                  id="dwaa"
                                >
                                  <option value="0">Total Sales</option>
                                  <option value="1">
                                    Total Base Salary/Wages as % of Revenue
                                  </option>
                                  <option value="2">
                                    Daily OT Hours as % of Total Hours
                                  </option>
                                  <option value="3">
                                    Sales Per Employee Hour
                                  </option>
                                  <option value="4"># of FT Hours</option>
                                  <option value="5"># of PT Hours</option>
                                  <option value="6"># of Daily OT Hours</option>
                                  <option value="7"># of Total Hours</option>
                                  <option value="8">Total PT Base Wage</option>
                                  <option value="9">
                                    Total Base Salary/Wages
                                  </option>
                                  <option value="10"># of Sick Days</option>
                                  <option value="11">Total Revenue</option>
                                  <option value="12">Total Gross Sales</option>
                                  <option value="13">Total Net Sales</option>
                                  <option value="14">
                                    Avg Daily Gross Sales
                                  </option>
                                  <option value="15">
                                    Avg Daily Net Sales
                                  </option>
                                  <option value="16">
                                    Total Food Gross Sale
                                  </option>
                                  <option value="17">
                                    Total Food Net Sale
                                  </option>
                                  <option value="18">
                                    Total Alcoholic Beverage Gross Sale
                                  </option>
                                  <option value="19">
                                    Total Alcoholic Beverage Net Sale
                                  </option>
                                  <option value="20">
                                    Total Non-Alcoholic Beverage Gross Sale
                                  </option>
                                  <option value="21">
                                    Total Non-Alcoholic Beverage Net Sale
                                  </option>
                                </select>{" "}
                              </div>
                            </div>

                            <div class="distribution-chart dwaaDiv metricChart salesTrendingMetric">
                              <ul class="week-average">
                                <li>
                                  <div class="bar-wrap">
                                    <div class="progress-bar"></div>
                                    <span class="top-percent">$7,467.18 </span>
                                  </div>
                                </li>

                                <li>
                                  <div class="bar-wrap">
                                    <div class="progress-bar"></div>
                                    <span class="top-percent">$3,572.10 </span>
                                  </div>
                                </li>

                                <li>
                                  <div class="bar-wrap">
                                    <div class="progress-bar"></div>
                                    <span class="top-percent">$14,597.02 </span>
                                  </div>
                                </li>

                                <li>
                                  <div class="bar-wrap">
                                    <div class="progress-bar"></div>
                                    <span class="top-percent">$3,405.74 </span>
                                  </div>
                                </li>
                              </ul>
                              <ul class="week-average week-border">
                                <li>
                                  <label>Feb 22</label>
                                </li>
                                <li>
                                  <label>Mar 22</label>
                                </li>
                                <li>
                                  <label>Apr 22</label>
                                </li>
                                <li>
                                  <label>May 22</label>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6 mt-3">
                          <div class="shadowclass h-100 mt-0">
                            <h4 class="event-alert summary-event-alert">
                              {" "}
                              Sales Vs. Previous Period{" "}
                            </h4>
                            <div class="performance-sec customperform percent-sec-ms">
                              <ul class="border-bottom">
                                <li>
                                  <label>
                                    <strong>
                                      Current Period Performance vs.
                                    </strong>
                                  </label>
                                </li>
                                <li>
                                  <label>
                                    <strong>Total</strong>
                                  </label>
                                </li>
                                <li>
                                  <img src="/img/icon1.svg" alt="" />
                                </li>
                                <li>
                                  <img src="/img/icon2.svg" alt="" />
                                </li>
                                <li>
                                  <img src="/img/icon3.svg" alt="" />
                                </li>
                              </ul>
                              <ul>
                                <li>
                                  <label>
                                    Previous Period<label></label>
                                  </label>
                                </li>
                                <li>
                                  <span>-78%</span>
                                </li>
                                <li>
                                  <span>-78%</span>
                                </li>
                                <li>
                                  <span>-78%</span>
                                </li>
                                <li>
                                  <span>-78%</span>
                                </li>
                              </ul>
                              <ul>
                                <li>
                                  <label>
                                    Same Period Previous Year<label></label>
                                  </label>
                                </li>
                                <li>
                                  <span>N/A</span>
                                </li>
                                <li>
                                  <span>N/A</span>
                                </li>
                                <li>
                                  <span>N/A</span>
                                </li>
                                <li>
                                  <span>N/A</span>
                                </li>
                              </ul>
                              <ul class="border-bottom">
                                <li>
                                  <label>
                                    Record Period (01/01/70 - 31/01/70)
                                    <label></label>
                                  </label>
                                </li>
                                <li>
                                  <span>N/A</span>
                                </li>
                                <li>
                                  <span>N/A</span>
                                </li>
                                <li>
                                  <span>N/A</span>
                                </li>
                                <li>
                                  <span>N/A</span>
                                </li>
                              </ul>
                              <ul class="percentage_cir_rate">
                                <li>
                                  <label>
                                    % of Net Sales<label></label>
                                  </label>
                                </li>
                                <li>
                                  <span class="green-circle">100</span>
                                </li>
                                <li class="percentage_cir_li">
                                  <div class="progress-circle p33 ">
                                    <span>33</span>
                                    <div class="left-half-clipper">
                                      <div class="first50-bar"></div>
                                      <div class="value-bar"></div>
                                    </div>
                                  </div>
                                </li>

                                <li class="percentage_cir_li">
                                  <div class="progress-circle p33 ">
                                    <span>33</span>
                                    <div class="left-half-clipper">
                                      <div class="first50-bar"></div>
                                      <div class="value-bar"></div>
                                    </div>
                                  </div>
                                </li>

                                <li class="percentage_cir_li">
                                  <div class="progress-circle p33 ">
                                    <span>33</span>
                                    <div class="left-half-clipper">
                                      <div class="first50-bar"></div>
                                      <div class="value-bar"></div>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-lg-6 distri-nw mt-3">
                          <div class="shadowclass h-100 mt-0">
                            <div class="menu-itemss">
                              <h4 class="event-alert summary-event-alert">
                                Menu Item Popularity
                                <ul class="summary_filter add">
                                  <li
                                    class="active click_popularity"
                                    val="most"
                                  >
                                    <a href="javascript:void(0)">Most</a>
                                  </li>
                                  <li class=" click_popularity" val="least">
                                    <a href="javascript:void(0)">Least</a>
                                  </li>
                                </ul>
                              </h4>
                              <div class="performance-sec customperform">
                                <ul class="">
                                  <li>
                                    <a
                                      href="javascript:void(0)"
                                      class="menu_input activeText"
                                      val="0"
                                      data-val="most"
                                    >
                                      <label>Total</label>
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href="javascript:void(0)"
                                      class="menu_input"
                                      val="1"
                                      data-val="most"
                                    >
                                      <img src="/img/icon1.svg" alt="" />
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href="javascript:void(0)"
                                      class="menu_input"
                                      val="3"
                                      data-val="most"
                                    >
                                      <img src="/img/icon2.svg" alt="" />
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href="javascript:void(0)"
                                      class="menu_input"
                                      val="2"
                                      data-val="most"
                                    >
                                      <img src="/img/icon3.svg" alt="" />
                                    </a>
                                  </li>
                                </ul>
                              </div>
                              <div class="table-responsive menu_input_data">
                                <table
                                  class="checklist-table getMi_popularity"
                                  cellspacing="0"
                                  cellpadding="0"
                                  width="100%"
                                  id="mostDS"
                                >
                                  <thead>
                                    <tr>
                                      <th class="no-border"></th>
                                      <th class="no-border"></th>
                                      <th colspan="2">Current</th>
                                      <th colspan="2">Previous Period</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <th></th>
                                      <th valign="bottom" width="45%">
                                        Menu Item Name
                                      </th>
                                      <th class="header colored-th text-right">
                                        # Sold
                                      </th>
                                      <th class="header text-right">
                                        % of Tickets
                                      </th>
                                      <th class=" text-right"># Sold</th>
                                      <th class=" text-right"> % of Tickets</th>
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                    <tr>
                                      <td>
                                        <span class="list-li">1</span>
                                      </td>
                                      <td>Caesar Salad</td>
                                      <td class="colored-th text-right">17</td>
                                      <td class=" text-right">10.63%</td>
                                      <td class=" text-right">9</td>
                                      <td class=" text-right">0%</td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <span class="list-li">2</span>
                                      </td>
                                      <td>Chicken Taco</td>
                                      <td class="colored-th text-right">12</td>
                                      <td class=" text-right">7.5%</td>
                                      <td class=" text-right">36</td>
                                      <td class=" text-right">0%</td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <span class="list-li">3</span>
                                      </td>
                                      <td>
                                        Beer Battered Fish &amp; Chips 1-for-1
                                        Deal
                                      </td>
                                      <td class="colored-th text-right">11</td>
                                      <td class=" text-right">6.88%</td>
                                      <td class=" text-right">14</td>
                                      <td class=" text-right">0%</td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <span class="list-li">4</span>
                                      </td>
                                      <td>Harry's Signature Wings</td>
                                      <td class="colored-th text-right">9</td>
                                      <td class=" text-right">5.63%</td>
                                      <td class=" text-right">6</td>
                                      <td class=" text-right">0%</td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <span class="list-li">5</span>
                                      </td>
                                      <td>Truffle Fries</td>
                                      <td class="colored-th text-right">9</td>
                                      <td class=" text-right">5.63%</td>
                                      <td class=" text-right">3</td>
                                      <td class=" text-right">0%</td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <span class="list-li">6</span>
                                      </td>
                                      <td>Beef Rendang W Basmati Rice</td>
                                      <td class="colored-th text-right">7</td>
                                      <td class=" text-right">4.38%</td>
                                      <td class=" text-right">7</td>
                                      <td class=" text-right">0%</td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <span class="list-li">7</span>
                                      </td>
                                      <td>Chocolate Lava Cake</td>
                                      <td class="colored-th text-right">6</td>
                                      <td class=" text-right">3.75%</td>
                                      <td class=" text-right">7</td>
                                      <td class=" text-right">0%</td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <span class="list-li">8</span>
                                      </td>
                                      <td>New York Cheese Cake</td>
                                      <td class="colored-th text-right">5</td>
                                      <td class=" text-right">3.13%</td>
                                      <td class=" text-right">2</td>
                                      <td class=" text-right">0%</td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <span class="list-li">9</span>
                                      </td>
                                      <td>
                                        Flatbread Mushroom &amp; Truffle Oil
                                      </td>
                                      <td class="colored-th text-right">5</td>
                                      <td class=" text-right">3.13%</td>
                                      <td class=" text-right">1</td>
                                      <td class=" text-right">0%</td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <span class="list-li">10</span>
                                      </td>
                                      <td>Caprese 1-for-1 Deal</td>
                                      <td class="colored-th text-right">5</td>
                                      <td class=" text-right">3.13%</td>
                                      <td class=" text-right">31</td>
                                      <td class=" text-right">0%</td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6 distri-nw ticket-amount mt-3">
                          <div class="shadowclass h-100 mt-0">
                            <h4 class="event-alert summary-event-alert">
                              Sales Proportions
                            </h4>
                            <div class="select-comparison">
                              <label>Select Metric</label>
                              <div class="select-div col-4">
                                <select name="metric_select" id="metric_select">
                                  <option value="service_period_id">
                                    Service Period
                                  </option>
                                  <option value="payment_method_id">
                                    Payment Method
                                  </option>
                                  <option value="sales_types_id">
                                    Sales Type
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div class="row lbbbc_div metric_input">
                              <div class="total_orders_color col-4">
                                <h4 class="event-alert">Total Sales</h4>
                                <div class="color-bar-sec">
                                  <div
                                    class="color-bar-sec-child"
                                    id="setheight"
                                  ></div>
                                </div>
                              </div>

                              <div class=" col-8">
                                <div class="inner-space screen-scroll labor_cost_category mCS_destroyed">
                                  <div class="table-responsive">
                                    <table
                                      class="checklist-table lbbbcTable"
                                      id="tblhgt"
                                      cellpadding="0"
                                      cellspacing="0"
                                      width="100%"
                                    >
                                      <thead>
                                        <tr>
                                          <th class="header" width="22">
                                            &nbsp;
                                          </th>
                                          <th class="header">Category</th>
                                          <th
                                            class="header text-right percent-total"
                                            align="right"
                                          >
                                            % of Total
                                          </th>
                                          <th class="header text-right">
                                            Amount
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody class="tbodyCategories">
                                        <tr>
                                          <td>
                                            <span class="color-box color1">
                                              1
                                            </span>
                                          </td>
                                          <td>Dinner </td>
                                          <td align="right">21.70 </td>
                                          <td class="fromInner" align="right">
                                            $708.51{" "}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <span class="color-box color2">
                                              2
                                            </span>
                                          </td>
                                          <td>Lunch </td>
                                          <td align="right">78.30 </td>
                                          <td class="fromInner" align="right">
                                            $2,557.02{" "}
                                          </td>
                                        </tr>
                                      </tbody>
                                      <tbody>
                                        <tr class="actual_cost_row">
                                          <td>&nbsp;</td>
                                          <td class="total-payroll">Total </td>
                                          <td align="right">100 </td>
                                          <td align="right">$3,265.53 </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default General;
